module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/9 Velka plec ocistena.jpg";